import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Version from "version";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Slide from '@material-ui/core/Slide';
import Button from "components/CustomButtons/Button";
import ButtonX from '@material-ui/core/Button';
import ReactLoading from 'react-loading';
import Icon from "../components/Selfcare/Common/Icon";
import TextField from '@material-ui/core/TextField';
import pink from '@material-ui/core/colors/pink';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle";

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);


const styles = theme => ({
    ...pricingPageStyle,
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(1),
    },
    cssLabel: {
        '&$cssFocused': {
            color: pink[500],
        },
    },
    cssFocused: {},
    cssUnderline: {
        '&:after': {
            borderBottomColor: pink[500],
        },
    },
});

const theme = createMuiTheme({
    palette: {
        primary: pink,
    },
    typography: { useNextVariants: true },
});


class ActivateSimcard extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("ActivateSimcard", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            Password: '',
            SimNo: '',
            OrderSent: false,
            OrderError: '',
            buzy: false,
            ErrorField: '',
            ErrorText: '',
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.OrderSent && !this.state.OrderSent) {
            MySwal.fire({
                title: this.props.t('selfcare:message.currently-activating-sim'),
                html: this.props.t('selfcare:message.few-minutes-otherwise-restart-phone'),
                icon: 'success',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.setState({ redirect: true, toUrl: '/overview' });
            });
        }
        if (nextState.OrderError && !this.state.OrderError) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.order-failed'),
                html: nextState.OrderError,
                icon: 'error',
                confirmButtonColor: '#e91e63',
            });
            this.setState({ buzy: false });
        }
        if (nextState.ErrorField && !this.state.ErrorField) {
            this.setState({ buzy: false });
            this.setFocus(nextState.ErrorField);
        }
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }
    setFocus = fieldName => {
        switch (fieldName) {
            case "Password":
                if (this.Password) {
                    setTimeout(() => {
                        this.Password.focus();
                    }, 10);
                }
                break;
            case "SimNo":
                if (this.SimNo) {
                    setTimeout(() => {
                        this.SimNo.focus();
                    }, 10);
                }
                break;
        }
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.value, ErrorField: '' });
    }

    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }
    render() {
        console.debug('OrderSimcard render');
        const classes = this.props;
        const { t } = this.props;
        return (
            <div style={{ height: '100vh' }}>
                {this.state.redirect ? <Redirect to={this.state.toUrl} /> : null}
                    <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={10} md={8} lg={6} xl={4} >
                                <Icon name="simcard" size={48} color="#FFFFFF" />
                                <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                    {t('selfcare:item.activate-new-sim')}
                                </div>
                                <div style={{ fontSize: '14px' }}>
                                    {t('selfcare:item.ordered-sim-sent')}
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                    <form onSubmit={(e) => { e.preventDefault(); this.setState({ buzy: true, ErrorField: '' }); this.dispatchState({ PerformChange: { Password: this.state.Password, SimNo: this.state.SimNo } }); }}>
                        <GridContainer justify="center">
                            <MuiThemeProvider theme={theme}>
                                <GridItem xs={12} sm={10} md={8} lg={6} xl={4} >
                                    {this.state.UnblockFirst && <div style={{ paddingTop: '20px', paddingLeft: '10px', paddingRight: '10px' }}>
                                        <p style={{ fontSize: '14px' }}>{t('selfcare:info.to-activate-sim-open-subscription')}</p>
                                        <div style={{ maxWidth: '320px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'Password'}
                                                disabled={this.state.buzy}
                                                label={t('selfcare:label.password-submitted-at-block')}
                                                value={this.state.Password}
                                                onChange={this.handleChange('Password')}
                                                id="Password"
                                                className={classes.textField}
                                                inputProps={{ maxLength: 30, type: 'password' }}
                                                helperText={this.state.ErrorField === 'Password' && this.state.ErrorText}
                                                inputRef={(el) => { this.Password = el }}
                                            />
                                        </div>
                                    </div>}
                                    {this.state.CanActivate && <div style={{ paddingTop: '20px', paddingLeft: '10px', paddingRight: '10px' }}>
                                        <div style={{ maxWidth: '320px' }}>
                                            <TextField fullWidth error={this.state.ErrorField === 'SimNo'}
                                                disabled={this.state.buzy}
                                                label={t('selfcare:label.final-6-digits-sim')}
                                                value={this.state.SimNo}
                                                onChange={this.handleChange('SimNo')}
                                                id="SimNo"
                                                className={classes.textField}
                                                inputProps={{ maxLength: 30, type: 'tel' }}
                                                helperText={this.state.ErrorField === 'SimNo' && this.state.ErrorText}
                                                inputRef={(el) => { this.SimNo = el }}
                                            />
                                        </div>
                                        <GridContainer direction="row">
                                            <GridItem>
                                                <div style={{ paddingTop: '20px' }}>
                                                    <Button type="submit" size="sm" disabled={this.state.buzy} variant="contained" style={{ borderRadius: '19px', marginRight: '10px' }} color="rose">{t('selfcare:button.activate')}</Button>
                                                    <ButtonX id='cancel' size="small" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}>{t('selfcare:button.cancel')}</ButtonX>
                                                </div>
                                            </GridItem>
                                        </GridContainer>
                                    </div>}
                                    {!this.state.CanActivate && <div>
                                        {t('selfcare:error.no-order-sim-found')}<br />
                                        <Button id='back' color="rose" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}><Icon name="back" size={32} color="#FFFFFF" />{t('selfcare:button.back')}</Button>
                                    </div>}
                                    {this.state.buzy && <GridItem>
                                        <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                    </GridItem>}
                                </GridItem>
                            </MuiThemeProvider>
                        </GridContainer>
                    </form>
            </div>
        );
    }
}
ActivateSimcard.propTypes = {
};

export default compose(
    withStyles(styles),
    withTranslation(),
)(withAITracking(reactPlugin, ActivateSimcard));

